import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:5000';


export const login = async (email, password) => {
  const response = await axios.post(`${API_BASE_URL}/auth/login`, { email, password }, {
    withCredentials: true, // Ensures cookies are sent/received
  });
  return response.data;
};

export const register = async (username, email, password) => {
  const response = await axios.post(`${API_BASE_URL}/auth/register`, { username, email, password });
  return response.data;
};

export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

export const setAuthToken = (token) => {
  localStorage.setItem('authToken', token);
};

export const removeAuthToken = () => {
  localStorage.removeItem('authToken');
};

// Set the Authorization header for Axios
export const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      const token = getAuthToken();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export const refreshToken = async () => {
  const response = await axios.post(`${API_BASE_URL}/auth/token/refresh`, {}, {
    withCredentials: true,
  });
  return response.data;
};
